import html from "./UnsupportedStep.html"

var module = angular.module("ResearchKitApplicationModule");

module.directive("unsupportedStep",
	[function () {
		return {
			template: html,
			replace: false,
			restrict: "E",
			scope: {
				"stepManager": "="
			}
		};
	}]
);